(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/pages/page-maintenance.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/pages/page-maintenance.js');
"use strict";


const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  header,
  body,
  icon
} = svs.bingo_react.data.maintenance;
const Maintenance = () => React.createElement("main", {
  className: "bingo-maintenance"
}, React.createElement(Icon, {
  icon: icon ? icon : 'icecream',
  size: "1100"
}), React.createElement("h2", {
  className: "bingo-maintenance__header"
}, header), body && React.createElement("h3", {
  className: "bingo-maintenance__body"
}, body), React.createElement(Button, {
  className: "bingo-maintenance__btn",
  href: "/",
  rounded: true
}, "Till startsidan"));
setGlobal('svs.bingo_react.pages.Maintenance', Maintenance);

 })(window);